const pad2 = (value: number) => String(value).padStart(2, '0');
const pad3 = (value: number) => String(value).padStart(3, '0');

// Locale-safe (ASCII digits) formatting for API params.
export const formatLocalDateParam = (date: Date) => {
  const y = date.getFullYear();
  const m = pad2(date.getMonth() + 1);
  const d = pad2(date.getDate());
  return `${y}-${m}-${d}`;
};

export const formatLocalDateTimeParam = (date: Date) => {
  const y = date.getFullYear();
  const m = pad2(date.getMonth() + 1);
  const d = pad2(date.getDate());
  const hh = pad2(date.getHours());
  const mm = pad2(date.getMinutes());
  const ss = pad2(date.getSeconds());
  const ms = pad3(date.getMilliseconds());
  return `${y}-${m}-${d}T${hh}:${mm}:${ss}.${ms}`;
};
